var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', _vm._b({}, 'sub-visual', _vm.visual, false)), _c('div', {
    staticClass: "client-content-wrap"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('business-intro', _vm._b({}, 'business-intro', _vm.intro, false))], 1)], 1), _c('section', {
    staticClass: "client-section"
  }, [_c('v-img', {
    staticClass: "d-md-none",
    attrs: {
      "src": "/images/business/domestic/rights/middle.jpg",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "d-none d-md-block"
  }, [_c('v-card', {
    attrs: {
      "img": "/images/business/domestic/rights/business.jpg",
      "color": "#FEFCFB",
      "tile": "",
      "flat": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 1920 / 432
    }
  }, [_c('v-container', {
    staticClass: "h-100 py-50"
  }, [_c('v-row', {
    staticClass: "h-100",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "5"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "tit tit--sm line-height-15 font-weight-regular"
  }, [_vm._v(" 모든 아이들이 "), _c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("보호받고 존중받으며")]), _vm._v(" "), _c('br'), _c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("스스로의 권리를 누릴 수 있도록")]), _vm._v(" 지원합니다. ")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "page-text page-text--lg grey-1--text"
  }, [_vm._v(" 위드캔복지재단과 함께하면, 아이들이 차별과 어려움을 넘어 "), _c('br'), _vm._v(" 존중과 보호 속에서 꿈과 희망을 키울 수 있습니다. ")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("주요 프로그램")])]), _c('program-list', {
    attrs: {
      "items": _vm.programs
    }
  })], 1)], 1)]), _c('section', [_c('bottom-banner', {
    attrs: {
      "item": _vm.banner
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }